module.exports = __webpack_public_path__ + "img/kommune-1534.ef3b289a.svg";